module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      savedWallsPicker: true, active: _vm.active, noSlickNav: _vm.itemsInRow >= _vm.savedWalls.length
    }
  }, [(_vm.savedWalls && _vm.savedWalls.length) ? _c('div', {
    staticClass: "listing",
    attrs: {
      "id": "savedWallsScroller"
    }
  }, _vm._l((_vm.savedWalls), function(item, index) {
    return _c('div', {
      staticClass: "item hover-fade",
      on: {
        "click": function($event) {
          _vm.pickItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "image relative",
      style: ({
        backgroundImage: 'url(' + _vm.getImage(item) + ')'
      })
    }, [_c('loader', {
      attrs: {
        "classes": "cover dimmer",
        "fade-in": "fadeIn",
        "fade-out": "fadeOut",
        "identifier": 'pickWall' + item.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(item.settings.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "remove smooth",
      on: {
        "click": function($event) {
          _vm.deleteItem(item, $event, index)
        }
      }
    }, [_c('loader', {
      attrs: {
        "inline": true,
        "classes": "",
        "identifier": 'deleteSave' + item.id
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash"
    })], 1)], 1)])])
  })) : _vm._e(), _vm._v(" "), (!_vm.savedWalls.length && !_vm.loading) ? _c('div', {
    staticClass: "noSaves"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('noSavedWalls')) + " ")])])]) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "fade-in": "fadeIn",
      "fade-out": "fadeOut",
      "classes": "cover dimmer",
      "loading": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a71e35a!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Picker/SavedWallsPicker.vue
// module id = 165
// module chunks = 0